import './Login.scss';
import Component from './Login.js';
export default Component;
